import { render } from "./PastAppointmentsView.vue?vue&type=template&id=53a3bb46"
import script from "./PastAppointmentsView.vue?vue&type=script&lang=js"
export * from "./PastAppointmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__